module.exports = "body :host {\n  visibility: hidden; }\n\nbody.hide-left-column :host {\n  visibility: visible; }\n\n:host {\n  position: absolute;\n  top: 4em;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #FFFFFF; }\n\n.main-view {\n  height: 100%;\n  overflow: auto; }\n\n@media (min-width: 768px) {\n  :host {\n    width: auto;\n    visibility: visible !important;\n    left: 20em;\n    top: 5em; } }\n\n@media (min-width: 992px) {\n  :host {\n    width: auto;\n    left: 30em;\n    top: 7em; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-view/main-view.component.scss
// module id = ./src/app/main-view/main-view.component.scss
// module chunks = main